export type ProductCategoryRef = {CategoryID: number};

/** Category IDs that render a Category control. Replaces `ui.categoryIds.push` so retry cannot append duplicates. */
export const categoryIdsFromProduct = (categories: ProductCategoryRef[]): number[] => {
    const unique = [...new Set(categories.map(m => m.CategoryID))];
    return unique.filter(id => categories.filter(x => x.CategoryID === id).length > 1);
};

export const createDefaultProductGlass = (): {id: number; title: string; price: string}[] => [
    {id: 1, title: 'Standard', price: '$0'},
    {id: 2, title: 'Reflection Control', price: '$0'},
    {id: 3, title: 'Conservation UV', price: '$0'},
    {id: 4, title: 'UV & Reflection Control', price: '$0'},
];

/** Init-derived store fields that retry must restore to constructor defaults. */
export type ProductInitDerivedFields = {
    ready: boolean;
    prod: unknown;
    si: unknown;
    ps: object;
    pcs: unknown;
    frameV2: unknown;
    glass_prices: unknown[];
    selected_doc_size: number;
    currentGradSchoolID: number;
    hasDYFLinoNonProduct: boolean;
    hasSomeProductLino: boolean;
    hasOnlyOneProductLino: boolean;
    RenderingV2: boolean;
    docsizes_available: unknown[];
    docsizes_has_different_names: boolean;
    docsizes_name: string;
    docsizes_multiple_active: boolean;
    docsizes_enabled: boolean;
    docsizes_selected_id: number;
    docsizes_orig_id: number;
    ppi_w: number;
    ppi_h: number;
    ppi_w_max: number;
    ppi_h_max: number;
    ppi_w_actual: number;
    ppi_h_actual: number;
    product_thumbnail_height: number;
    IsPortal3: boolean;
    apiError: boolean;
    errorLog: string;
    errorLogInfo: string;
    __fast_ship_orig: boolean;
    __fast_ship_warned: boolean;
};

export const resetProductInitDerivedFields = (store: ProductInitDerivedFields): void => {
    store.ready = false;
    store.prod = undefined;
    store.si = undefined;
    store.ps = {};
    store.pcs = undefined;
    store.frameV2 = undefined;
    store.glass_prices = [];
    store.selected_doc_size = 3;
    store.currentGradSchoolID = -1;
    store.hasDYFLinoNonProduct = false;
    store.hasSomeProductLino = false;
    store.hasOnlyOneProductLino = false;
    store.RenderingV2 = false;
    store.docsizes_available = [];
    store.docsizes_has_different_names = false;
    store.docsizes_name = '';
    store.docsizes_multiple_active = false;
    store.docsizes_enabled = false;
    store.docsizes_selected_id = -1;
    store.docsizes_orig_id = -1;
    store.ppi_w = -1;
    store.ppi_h = -1;
    store.ppi_w_max = -1;
    store.ppi_h_max = -1;
    store.ppi_w_actual = -1;
    store.ppi_h_actual = -1;
    store.product_thumbnail_height = 75;
    store.IsPortal3 = false;
    store.apiError = false;
    store.errorLog = '';
    store.errorLogInfo = '';
    store.__fast_ship_orig = false;
    store.__fast_ship_warned = false;
};
